import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DEFAULT_OG_IMAGE, SITE_NAME, SITE_NAME_FA } from '../../seo/config';
import { useI18n } from '../../hooks/useI18n';

export const SharePageSeo = ({ title, canonical }) => {
  const { t, language } = useI18n();
  const siteName = language === 'fa' ? SITE_NAME_FA : SITE_NAME;
  const pageTitle = title ? `${title} | ${siteName}` : t('sharedConversationBadge');
  const description = t('sharedConversationSeoDescription');
  const url = canonical || (typeof window !== 'undefined' ? window.location.href : '');

  return (
    <Helmet htmlAttributes={{ lang: language === 'fa' ? 'fa' : 'en' }}>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="noindex,nofollow" />
      {url ? <link rel="canonical" href={url} /> : null}

      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      {url ? <meta property="og:url" content={url} /> : null}
      <meta property="og:type" content="article" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={language === 'fa' ? 'fa_IR' : 'en_US'} />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
    </Helmet>
  );
};
